<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
        >
          <van-field 
            required
            v-model="loadingPage.loadingBackImg"
            label="背景图" 
            :rules="[{ required: true, message: '请上传背景图' }]">
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="loadingPage.loadingBackImgList" 
                :after-read="uploadImg"
                @delete="deleteImg"
              />
            </template>
          </van-field>
          <van-field
            required
            v-model="loadingPage.loadingText"
            label="加载文案"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入加载文案' }]"
          />
          <div class="tips">以“，”中文逗号进行分割</div>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
         <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    isAddLoadingPop: {
      type: Boolean,
      default: false
    },
    loadingPage: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    showPop: {
      get() {
        return this.isAddLoadingPop
      },
      set(val) {
        this.$emit('update:isAddLoadingPop', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  data() {
    return {
      isUploadImg: false,
      headImgList: [],
    }
  },
  
  methods: {
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(file) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.loadingPage.loadingBackImgList.push(currentFile)
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            this.loadingPage.loadingBackImg = fileUrl
            currentFile.status = 'done'
            delete this.loadingPage.loadingBackImgList[0].status
            delete this.loadingPage.loadingBackImgList[0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.isUploadImg = false
          this.deleteImg()
      });
    },
    deleteImg() {
      this.loadingPage.loadingBackImgList = []
      this.loadingPage.loadingBackImg = ''
    },
   
    submit() {
      // 图片上传中
      if (this.isUploadImg) return
      this.$refs.form.validate().then(async res => {
        if (this.from == 'manager') {
          const {activityId,id=''} = this.loadingPage
          await this.$api.typeTest.saveStylePage({
            id,
            activityId,
            pageType: 'loading',
            pageMap:this.loadingPage
          })
        }
        this.$emit('loadingPageSaveSuccess', this.loadingPage)
        this.$toast('保存成功');
        this.showPop = false
      }).catch(err => {
        this.$toast(err[0].message);
        this.isClike = true
      })
    },
    cancel() {
      this.showPop = false
      this.isClike = true
    },
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
.content {
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>